import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.components.ActiveLegalEntitySelect`

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Select entity',
  },
  placeholderMulti: {
    id: `${scope}.placeholderMulti`,
    defaultMessage: 'Select entities',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Legal entity',
  },
})
